import { render } from "./PostTable.vue?vue&type=template&id=3d665e0a"
import script from "./PostTable.vue?vue&type=script&lang=js"
export * from "./PostTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__